import { render, staticRenderFns } from "./InputAddress.vue?vue&type=template&id=8b71ad38&"
import script from "./InputAddress.vue?vue&type=script&lang=js&"
export * from "./InputAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/production/spf-sexosafe-ezplatform/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8b71ad38')) {
      api.createRecord('8b71ad38', component.options)
    } else {
      api.reload('8b71ad38', component.options)
    }
    module.hot.accept("./InputAddress.vue?vue&type=template&id=8b71ad38&", function () {
      api.rerender('8b71ad38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/TestForm/components/InputAddress/InputAddress.vue"
export default component.exports